import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center min-h-[calc(100vh-4rem)] px-4 bg-surface-50" }
const _hoisted_2 = { class: "w-full max-w-md -mt-16 md:-mt-24" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-bold mb-12 text-primary-800 text-center" }, [
  /*#__PURE__*/_createTextVNode(" 어떤 주제로"),
  /*#__PURE__*/_createElementVNode("br", { class: "md:hidden" }),
  /*#__PURE__*/_createTextVNode(" 포스트를 작성할까요? ")
], -1)
const _hoisted_4 = { class: "flex justify-center mb-8" }
const _hoisted_5 = { class: "text-surface-600 text-lg text-center mt-8" }

import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useArticleStore } from "../stores/articleStore";
import { useInputMode } from "../composables/useInputMode";
import SelectButton from "primevue/selectbutton";
import DirectTextInput from "../components/DirectTextInput.vue";
import KeywordInput from "../components/KeywordInput.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const topic = ref("");
const router = useRouter();
const articleStore = useArticleStore();
const { inputModes, inputMode } = useInputMode();

const searchNews = async () => {
  if (topic.value.trim()) {
    await articleStore.setTopic(topic.value.trim());
    router.push("/news-selection");
  }
};

const generatePostFromText = async (texts: string[]) => {
  await articleStore.setDirectTexts(texts);
  router.push("/result");
};

const inputModeDescription = computed(() =>
  inputMode.value === "keyword"
    ? "관련 뉴스를 찾아 포스트를 생성해드려요 ☺️"
    : "입력한 텍스트를 기반으로 포스트를 생성해드려요 ☺️"
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(SelectButton), {
          modelValue: _unref(inputMode),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputMode) ? (inputMode).value = $event : null)),
          options: _unref(inputModes),
          optionLabel: "name",
          optionValue: "value",
          allowEmpty: false,
          pt: {
            root: { class: 'flex rounded-md overflow-hidden shadow-sm' },
          }
        }, null, 8, ["modelValue", "options"])
      ]),
      (_unref(inputMode) === 'keyword')
        ? (_openBlock(), _createBlock(KeywordInput, {
            key: 0,
            modelValue: topic.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((topic).value = $event)),
            onGenerate: searchNews,
            class: "mb-8"
          }, null, 8, ["modelValue"]))
        : (_openBlock(), _createBlock(DirectTextInput, {
            key: 1,
            onGenerate: generatePostFromText,
            class: "mb-8"
          })),
      _createElementVNode("p", _hoisted_5, _toDisplayString(inputModeDescription.value), 1)
    ])
  ]))
}
}

})